module.exports = __webpack_public_path__ + "img/coach-detail-bg1.c7b05fed.png";